module.exports = __webpack_public_path__ + "img/logo-tvshows.4adca000.png";